
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const FinalCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Ready to Eliminate Processing Fees?
          </h2>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Join thousands of businesses saving money with our cash discount program
          </p>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Payment Processing</h3>
              <ul className="space-y-2 text-left">
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Eliminate processing fees</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>All major cards accepted</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Next-day funding available</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>POS systems & equipment</span>
                </li>
              </ul>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-4">Online Ordering</h3>
              <ul className="space-y-2 text-left">
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Custom branded mobile app</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Professional website</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Save 5-10% vs delivery apps</span>
                </li>
                <li className="flex items-center">
                  <CheckCircle className="h-4 w-4 mr-2 text-green-400" />
                  <span>Starting at $0/month</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Call to Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Button size="lg" variant="secondary" asChild>
              <a 
                href="https://merchantech.com/app/bradley-brown/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply Now - Start Processing Today
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
            <Link to="/doordash-integration">
              <Button size="lg" variant="hero">
                Get Online Ordering
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>

          {/* Contact Info */}
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold mb-4">Need Help Choosing?</h3>
            <p className="mb-4 opacity-90">
              Our payment processing experts are here to help you save money and grow your business.
            </p>
            <a 
              href="tel:9543992230"
              className="inline-flex items-center text-lg font-semibold hover:text-yellow-300 transition-colors"
            >
              <Phone className="h-5 w-5 mr-2" />
              Call (954) 399-2230
            </a>
            <p className="text-sm opacity-75 mt-2">
              Available Monday-Friday, 9AM-6PM EST
            </p>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full opacity-50"></div>
      <div className="absolute -bottom-10 -left-10 w-60 h-60 bg-white/5 rounded-full opacity-50"></div>
    </section>
  );
};

export default FinalCTA;
